import { useNavigate } from 'react-router-dom';
import { NewsArticle } from '../page';

interface RelatedNewsProps {
  relatedNews: NewsArticle[];
}

export default function RelatedNews({ relatedNews }: RelatedNewsProps) {
  const navigate = useNavigate();

  if (relatedNews.length === 0) return null;

  return (
    <section className="py-10 md:py-14 lg:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-5 md:px-6 lg:px-8">
        <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 md:mb-8">相关新闻</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {relatedNews.map((item) => {
            const dateObj = item.published_at ? new Date(item.published_at) : null;
            const month = dateObj ? String(dateObj.getMonth() + 1).padStart(2, '0') : '';
            const day = dateObj ? String(dateObj.getDate()).padStart(2, '0') : '';
            const dateLabel = dateObj
              ? `${dateObj.getFullYear()}-${month}-${day}`
              : '';

            return (
              <div
                key={item.id}
                onClick={() => navigate(`/news/${item.id}`)}
                className="bg-white rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer group"
              >
                <div className="relative h-44 md:h-48 overflow-hidden">
                  {item.cover_image ? (
                    <img
                      src={item.cover_image}
                      alt={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    />
                  ) : (
                    <div className="w-full h-full bg-gradient-to-br from-teal-100 to-teal-200"></div>
                  )}
                  {dateObj && (
                    <div className="absolute top-3 right-3 bg-white px-2 py-1.5 rounded-lg">
                      <div className="text-xs text-gray-500 leading-tight">{month}月</div>
                      <div className="text-sm font-bold text-gray-900 leading-tight">{day}日</div>
                    </div>
                  )}
                </div>
                <div className="p-4 md:p-5">
                  {item.category && (
                    <span className="inline-block px-2.5 py-1 bg-teal-100 text-teal-700 text-xs font-semibold rounded-full mb-2.5">
                      {item.category}
                    </span>
                  )}
                  <h3 className="text-sm md:text-base font-bold text-gray-900 mb-2 line-clamp-2 leading-snug group-hover:text-teal-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-gray-500 line-clamp-2 leading-relaxed">{item.summary}</p>
                  <div className="flex items-center justify-between text-xs text-gray-400 mt-3 pt-3 border-t border-gray-50">
                    <span>{dateLabel}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>{(item.view_count ?? 0).toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
